/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import { UseLoggedContext } from '@mercadoni/sinister/dist/cjs/authentication/contexts'
import { FC } from 'react'
import styles from './Button.module.css'
import MainText from './MainText'
import SecondaryText from './SecondaryText'

interface ButtonDecoratorProps {
  onClick?: () => void
  className?: string
}

const Button: FC<ButtonDecoratorProps> = ({ onClick, className }) => {
  const { isLogged } = UseLoggedContext()
  const { customer, copies, isLightBackground, site } = useHeaderContext()
  const customerName = customer && customer?.name
  const { clients } = copies
  const { user } = clients?.generalheader || {}

  const buttonClassName = `${styles.button} ${
    isLightBackground ? styles.lightBackground : styles.darkBackground
  } ${className || ''} account-menu`

  return (
    <button className={buttonClassName} onClick={onClick}>
      <div className="account-menu__icon">
        <Icon size={24} className="ph-user" aria-label="Account" />
      </div>
      <div className="account-menu__content">
        <MainText>
          {`${user?.hi} ${isLogged ? customerName : user?.login}`}
        </MainText>
        {site !== 'sales' && <SecondaryText>{user?.account}</SecondaryText>}
      </div>
    </button>
  )
}

export default Button
